module.exports = __webpack_public_path__ + "static/media/GestãoLoja.f3798c30.webp";